import { labels } from './sendings'

export default {
  title: 'Переотправления',

  labels,

  errors: {
    onTimeout: {
      timeout: 'Не может быть меньше 10'
    }
  }
}
